module.exports = __webpack_public_path__ + "static/death_kiss-63254ff029f06328a0ab74bb484479b3.jpeg";